module.exports = __webpack_public_path__ + "static/media/spinner.f9758685.gif";